import { render, staticRenderFns } from "./PaymentTransactionForm.vue?vue&type=template&id=162a5ef2&"
import script from "./PaymentTransactionForm.vue?vue&type=script&lang=js&"
export * from "./PaymentTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports